import styled from '@emotion/styled';
import { breakpoints } from '~/theme/breakpoints';
import { Link } from '~/shared/components';

//Main Tab Content
export const StyledContentMap = styled.div<{ hide?: boolean }>(({ hide }) => ({
    width: '100%',
    display: hide ? 'none' : 'flex',
    flexDirection: 'column',
    [breakpoints.md]: {
        flexDirection: 'row',
    },
}));

export const StyledMap = styled.div(({ theme }) => ({
    display: 'block',
    order: 0,
    height: '250px',
    '.mapHelper__cluster': {
        backgroundColor: `${theme.colors.orangeMedium}`,
        borderRadius: theme.space[6],
        div: {
            color: `${theme.colors.white} !important`,
        },
    },
    [breakpoints.sm]: {
        height: '100%',
    },
    [breakpoints.md]: {
        order: 1,
        display: 'block',
        width: '80%',
    },
}));
export const StyledMapList = styled.div(() => ({
    width: '100%',
    order: 1,
    [breakpoints.md]: {
        display: 'block',
        minWidth: '414px',
        width: '20%',
        order: 0,
    },
}));

export const StyledInputFieldWrapper = styled.div(({ theme }) => ({
    position: 'relative',
    flexDirection: 'row',
    display: 'flex',
    borderRadius: theme.sizes.cornerRadius,
    alignItems: 'center',
    marginTop: theme.space[1],
    marginBottom: theme.space[1],

    border: `1px solid ${theme.colors.black}`,
    backgroundColor: theme.colors.white,
    [`&:active ${StyledLabel}`]: {
        color: theme.colors.black,
    },
}));

export const StyledButton = styled.button(({ theme }) => ({
    border: 'none',
    background: 'none',
    textDecoration: 'underline',
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    padding: 0,
    margin: 0,
    outline: 'none',
    cursor: 'pointer',
    ['svg']: {
        width: 20,
        height: 20,
    },
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledSearchLocation = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.space[2],
}));

export const StyledLi = styled.li(({ theme }) => ({
    width: '100%',
    listStyle: 'none',
    padding: theme.space[3],
    borderBottom: `1px solid ${theme.colors.brownLight}`,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    background: theme.colors.white,
}));

export const StyledInput = styled.input(({ theme }) => ({
    ...theme.mixins.useTextStyle('formInput'),
    borderRadius: theme.sizes.cornerRadius,
    height: 40,
    color: theme.colors.black,
    border: 2,
    lineHeight: theme.lineHeights.single,
    position: 'relative',
    cursor: 'type',
    outline: 0,
    width: '100px',
    boxSizing: 'border-box',
    textAlign: 'left',
    display: 'block',
    padding: `0 ${theme.space[3]}`,
    '&::placeholder': {
        transition: '0.1s color',
        color: theme.colors.grey70,
    },
    '&:empty:placeholder-shown::placeholder': {
        color: 'transparent',
    },
    '&:focus:empty::placeholder': {
        color: theme.colors.grey70,
    },
    '&:not(:placeholder-shown) + label, &:focus + label': {
        backgroundColor: theme.colors.white,
        paddingLeft: theme.space[1],
        paddingRight: theme.space[1],
        transform: 'translateY(-30px)',
        ...theme.mixins.useTextStyle('formsLabelActive'),
    },
}));

export const StyledLabel = styled.label(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: theme.space[3],
    ...theme.mixins.useTextStyle('sectionLabel'),
    transition: '0.1s transform, 0.1s width',
    color: theme.colors.black,
    transform: 'translateY(-50%)',
    maxWidth: `calc(100% - ${theme.space[3]} - ${theme.space[3]})`,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    transformOrigin: 'left top',
    pointerEvents: 'none',
}));
export const StyledWrapper = styled.div(() => ({
    position: 'relative',
    flexGrow: 1,
}));
export const StyledBack = styled.div(({ theme }) => ({
    display: 'flex',
    padding: `${theme.space[4]} ${theme.space[2]}}`,
    alignItems: 'center',
    justifyContent: 'flex-start',
    alignContent: 'center',
    svg: {
        cursor: 'pointer',
        height: '16px',
        width: '16px',
        margin: `0 ${theme.space[2]} 0 ${theme.space[2]}`,
        color: theme.colors.black,
        ':focus-visible': {
            boxShadow: theme.shadows.accessibility,
        },
    },
    [breakpoints.md]: {
        padding: `0 ${theme.space[4]} ${theme.space[3]}`,
    },
}));
export const StyledIconButton = styled(Link)(({ theme }) => ({
    ...theme.mixins.useTextStyle('bodySmall'),
    textAlign: 'center',
    textJustify: 'auto',
    display: 'flex',
    flexBasis: 0,
    flexGrow: 1,
    letterSpacing: 0,
    alignItems: 'center',
    justifyContent: 'flex-start',
    lineHeight: theme.lineHeights['base'],
    padding: `0 ${theme.space[1]} 0 0`,
}));

export const StyledSearchWrapper = styled.div(({ theme }) => ({
    padding: theme.space[3],

    [breakpoints.md]: {
        padding: `0 ${theme.space[5]} ${theme.space[3]} ${theme.space[5]}`,
    },
}));
